var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"55vh","width":"100%"},attrs:{"id":("pieChart" + (_vm.pieData.id ? _vm.pieData.id : ''))}})}
var staticRenderFns = []

export { render, staticRenderFns }